if (!customElements.get("recipient-form")) {
  customElements.define(
    "recipient-form",
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-fields-live-region-${this.dataset.sectionId}`
        );
        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${this.dataset.sectionId}`
        );
        this.checkboxState = this.querySelector(
          `#Checkbox-state-${this.dataset.sectionId}`
        );
        this.hiddenControlField = this.querySelector(
          `#Recipient-control-${this.dataset.sectionId}`
        );
        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        );
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`
        );
        this.offsetProperty = this.querySelector(
          `#Recipient-timezone-offset-${this.dataset.sectionId}`
        );
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector(
          ".product-form__recipient-error-message-wrapper"
        );
        this.errorMessageList = this.errorMessageWrapper?.querySelector("ul");
        this.errorMessage =
          this.errorMessageWrapper?.querySelector(".error-message");
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener("change", this.onChange.bind(this));
        this.onChange();

        // Add the form submission event listener
        const form = document.querySelector('form[action="/cart/add"]');
        form.addEventListener("submit", this.handleSubmit.bind(this));
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.resetRecipientForm();
            }
          }
        );

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          }
        );

        this.cartErrorUnsubscriber = subscribe(
          PUB_SUB_EVENTS.cartError,
          (event) => {
            if (
              event.source === "product-form" &&
              event.productVariantId.toString() === this.currentProductVariantId
            ) {
              this.displayErrorMessage(event.message, event.errors);
            }
          }
        );

        // Add the code to toggle the visibility of the form fields based on the checkbox state
        const recipientFields = this.querySelector(".recipient-fields");
        this.checkboxInput.addEventListener("change", () => {
          console.log("Checkbox state:", this.checkboxInput.checked);
          this.checkboxState.innerText = this.checkboxInput.checked
            ? "Checkbox is checked"
            : "Checkbox is not checked";
          recipientFields.style.display = this.checkboxInput.checked
            ? "block"
            : "none";
        });

        // Ensure initial state
        if (this.checkboxInput.checked) {
          recipientFields.style.display = "block";
        } else {
          recipientFields.style.display = "none";
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormExpanded;
          this.checkboxState.innerText = "Checkbox is checked";
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText =
            window.accessibilityStrings.recipientFormCollapsed;
          this.checkboxState.innerText = "Checkbox is not checked";
        }
      }

      inputFields() {
        return [
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput,
        ];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ""));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        try {
          this.clearErrorMessage();
          this.errorMessageWrapper.hidden = false;
          if (typeof body === "object") {
            this.errorMessage.innerText = this.defaultErrorHeader;
            Object.entries(body).forEach(([key, value]) => {
              const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
              const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
              const message = `${value.join(", ")}`;
              const errorMessageElement = this.querySelector(
                `#${errorMessageId}`
              );
              const errorTextElement =
                errorMessageElement?.querySelector(".error-message");
              if (!errorTextElement) return;

              if (this.errorMessageList) {
                this.errorMessageList.appendChild(
                  this.createErrorListItem(fieldSelector, message)
                );
              }

              errorTextElement.innerText = `${message}.`;
              errorMessageElement.classList.remove("hidden");

              const inputElement = this[`${key}Input`];
              if (!inputElement) return;

              inputElement.setAttribute("aria-invalid", true);
              inputElement.setAttribute("aria-describedby", errorMessageId);
            });
          } else {
            this.errorMessage.innerText = body;
          }
        } catch (error) {
          console.error("Error during displayErrorMessage:", error);
        }
      }

      createErrorListItem(target, message) {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.setAttribute("href", target);
        a.innerText = message;
        li.appendChild(a);
        li.className = "error-message";
        return li;
      }

      clearErrorMessage() {
        try {
          this.errorMessageWrapper.hidden = true;

          if (this.errorMessageList) this.errorMessageList.innerHTML = "";

          this.querySelectorAll(".recipient-fields .form__message").forEach(
            (field) => {
              field.classList.add("hidden");
              const textField = field.querySelector(".error-message");
              if (textField) textField.innerText = "";
            }
          );

          [
            this.emailInput,
            this.messageInput,
            this.nameInput,
            this.sendonInput,
          ].forEach((inputElement) => {
            inputElement.setAttribute("aria-invalid", false);
            inputElement.removeAttribute("aria-describedby");
          });
        } catch (error) {
          console.error("Error during clearErrorMessage:", error);
        }
      }

      resetRecipientForm() {
        try {
          if (this.checkboxInput.checked) {
            this.checkboxInput.checked = false;
            this.clearInputFields();
            this.clearErrorMessage();
          }
        } catch (error) {
          console.error("Error during resetRecipientForm:", error);
        }
      }

      handleSubmit(event) {
        // If checkbox is not checked, no need to validate
        if (!this.checkboxInput.checked) {
          return;
        }

        let hasError = false;

        if (!this.emailInput.value.trim()) {
          this.showFieldError(this.emailInput, "RecipientForm-email-error");
          hasError = true;
        } else {
          this.hideFieldError(this.emailInput, "RecipientForm-email-error");
        }

        if (!this.nameInput.value.trim()) {
          this.showFieldError(this.nameInput, "RecipientForm-name-error");
          hasError = true;
        } else {
          this.hideFieldError(this.nameInput, "RecipientForm-name-error");
        }

        if (!this.messageInput.value.trim()) {
          this.showFieldError(this.messageInput, "RecipientForm-message-error");
          hasError = true;
        } else {
          this.hideFieldError(this.messageInput, "RecipientForm-message-error");
        }

        if (!this.sendonInput.value.trim()) {
          this.showFieldError(this.sendonInput, "RecipientForm-send_on-error");
          hasError = true;
        } else {
          this.hideFieldError(this.sendonInput, "RecipientForm-send_on-error");
        }

        if (hasError) {
          event.preventDefault();
        }
      }

      showFieldError(field, errorId) {
        try {
          const errorElement = this.querySelector(
            `#${errorId}-${this.dataset.sectionId}`
          );
          errorElement.classList.remove("hidden");
          field.setAttribute("aria-invalid", true);
          field.setAttribute(
            "aria-describedby",
            `${errorId}-${this.dataset.sectionId}`
          );
        } catch (error) {
          console.error("Error during showFieldError:", error);
        }
      }

      hideFieldError(field, errorId) {
        try {
          const errorElement = this.querySelector(
            `#${errorId}-${this.dataset.sectionId}`
          );
          errorElement.classList.add("hidden");
          field.setAttribute("aria-invalid", false);
          field.removeAttribute("aria-describedby");
        } catch (error) {
          console.error("Error during hideFieldError:", error);
        }
      }
    }
  );
}
